import { Upload } from 'antd';
import { IUploadProps } from './entities';

const BCUpload = (props: IUploadProps) => (
	<Upload
		fileList={props.fileList}
		beforeUpload={props.beforeUpload}
		onChange={props.onChange}
	/>
);
export default BCUpload;
export { IUploadProps };
